import { Component, Input } from '@angular/core';
import { ITableView } from '../../interfaces';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})

export class TableComponent   {

    @Input()
    public tableView: ITableView;

}
